import axios from "@/utils/request"

/**
 * @function addSubscribeApi  => 患者提交预约
 * 
 * @param    data         发送的参数
 */
export function addSubscribeApi(data) {
    return axios({
        url: "/api/addSubscribe",
        method: "POST",
        data: data
    })
}